module.exports = __webpack_public_path__ + "static/media/Rectangle 112.fd4fd9a2.png";